import {
    GET_PRINTER_SETTINGS_STARTED,
    GET_PRINTER_SETTINGS_SUCCESS,
    GET_PRINTER_SETTINGS_FAILURE,
    UPDATE_PRINTER_SETTINGS_STARTED,
    UPDATE_PRINTER_SETTINGS_SUCCESS,
    UPDATE_PRINTER_SETTINGS_FAILURE,
    REMOVE_ERROR_MESSAGE
} from "../../constants/thermal-printer/thermalPrinter";

const initialState = {
    printerSettings: null,
    loading: false,
    error: null,
    message: null,
};

export default function tax(state = initialState, action) {
 switch (action.type) {
        case GET_PRINTER_SETTINGS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case GET_PRINTER_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                printerSettings: action.payload.data,
                error: null,
                message: null,
            };
        case GET_PRINTER_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null,
            };
        case UPDATE_PRINTER_SETTINGS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case UPDATE_PRINTER_SETTINGS_SUCCESS:
           
            return {
                ...state,
                loading: false,
                printerSettings: action.payload.data,
                message: "Printer settings were updated successfully!"
            };
        case UPDATE_PRINTER_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null
            };
        
        case REMOVE_ERROR_MESSAGE: {
            return {
                ...state,
                loading: false,
                error: null,
                message: null,
            };
        }
        default:
            return {
                ...state,
            };
    }
}
